// extracted by mini-css-extract-plugin
export var error404 = "error-404-module--error404--QSagK";
export var statusCode = "error-404-module--statusCode--Xw3uX";
export var statusMessage = "error-404-module--statusMessage--Umo0V";